<template>
  <div
    v-if="isOnline"
    class="auth-holder-ui"
  >
    <component
      :is="activeAuth"
      v-if="activeAuth"
      :default-type-auth="typeAuth"
      @change-auth="setActiveAuth"
      @hide-auth="hideAuth"
    />
  </div>
</template>

<script>
import ConsumerAuth from './ConsumerAuth.vue';
import SpecialistAuth from './SpecialistAuth.vue';

export default {
  name       : 'AuthHolder',
  components : {
    ConsumerAuth,
    SpecialistAuth
  },

  props: {
    typeAuth: {
      type    : String,
      default : ''
    }
  },

  data() {
    return {
      activeAuth : `${this.typeAuth}-auth`,
      isOnline   : true
    };
  },

  created() {
    document.addEventListener('auth:change-type', this.changeTypeComponentAuth);

    window.addEventListener('online', this.handleOfflineStatus);
    window.addEventListener('offline', this.handleOfflineStatus);

    this.handleOfflineStatus();
  },

  methods: {
    setActiveAuth(value) {
      this.activeAuth = `${value}-auth`;
    },

    hideAuth(value) {
      if (this.activeAuth === `${value}-auth`) {
        this.setActiveAuth(this.typeAuth);
      }
    },

    changeTypeComponentAuth(event) {
      if (event.detail && event.detail.type) {
        this.activeAuth = `${event.detail.type}-auth`;

        // При смене роли пользователя при авторизации -
        // на следующем шаге отображаем форму входа
        this.$nextTick().then(() => {
          document.dispatchEvent(new CustomEvent('auth:show', {
            detail: event.detail
          }));
        });
      }
    },

    handleOfflineStatus() {
      this.isOnline = navigator.onLine;
    }
  }
};
</script>
